import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { AuthPageLayout } from '@/components/auth/AuthPageLayout';

/**
 * Full-screen overlay covering the app for the whole logout transition —
 * teardown (clearAuth, cache drop) and navigation happen underneath, so the
 * user never sees the authenticated tree rendering against an emptied cache.
 * Visually mirrors the SSO callback page for continuity across the Zitadel
 * round-trip. A fixed overlay, not a route: the router keeps working below
 * it for the legacy invalidate→navigate sequence.
 */
export function LogoutSplash() {
  const { t } = useTranslation();
  return <TransitionSplash description={t('loggingOut')} />;
}

/**
 * Same overlay for workspace switching: covers the app from click until the
 * full page load into the new workspace. The login-style layout is
 * deliberate — index.html's static boot loader mimics AuthPageLayout, so
 * splash, the new document's first paint, and the login/boot visuals read
 * as one continuous screen.
 */
export function WorkspaceSwitchSplash() {
  const { t } = useTranslation();
  return <TransitionSplash description={t('switchingWorkspace')} />;
}

function TransitionSplash({ description }: { description: string }) {
  return (
    <div className="fixed inset-0 z-50 bg-background">
      <AuthPageLayout description={description}>
        <div className="flex justify-center">
          <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
        </div>
      </AuthPageLayout>
    </div>
  );
}
